import { Card, DatePicker, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { FullscreenOutlined, LoadingOutlined } from "@ant-design/icons";
import { disableFutureDates, formatDate } from "../../services/util";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import Chart from "react-google-charts";
import moment from "moment";
import { columnChartConfigurationOptions } from "../../config";

const chartConfigs = {
    ...columnChartConfigurationOptions,
    curveType: "function", // Smooths the lines
    series: {
        1: { color: "#fe8447", visibleInLegend: false },
    },
    legend: { position: "bottom" },
    hAxis: {
        slantedText: false,
        minTextSpacing: 30,
        maxAlternation: 1,
    },
    explorer: {
        actions: ["dragToZoom", "rightClickToReset"],
    },
    focusTarget: "category",
};
function MonthlyChart() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([[`months`, "counts"]]);
    const [enableZoom, setEnableZoom] = useState(false);
    const [formData, setFormData] = useState({
        start_date: formatDate(new Date(new Date().getFullYear(), 0, 1)),
        end_date: formatDate(new Date(new Date().getFullYear(), 11, 31)),
        staff_id,
    });

    const {
        status,
        data: daliySuccessRate,
        refetch,
    } = useQuery(
        "MonthlyManagementChart",
        async () => {
            return await HTTP(`/dashboard/getMonthlySuccessRate`, {
                ...formData,
            });
        },
        {
            enabled: false,
        },
    );

    useEffect(() => {
        refetch();
    }, [formData]);

    useEffect(() => {
        if (status === "success") {
            setChartData(
                daliySuccessRate.data.map((e, i) => {
                    if (i == 0) return [...e, "Threshold"];
                    else return [...e, 98.15];
                }),
            );
        }
    }, [status, daliySuccessRate]);

    return (
        <Card className="box-shadow">
            <div className="flex space-between">
                <strong>Monthly Success(%)</strong>
                <div className="flex flex-gap-10 align-center">
                    <DatePicker
                        defaultValue={moment()}
                        disabledDate={disableFutureDates}
                        picker="year"
                        placeholder="Year"
                        style={{ width: "100px" }}
                        onChange={(_, y) => {
                            console.log("year", y);
                            setFormData({
                                ...formData,
                                start_date: formatDate(new Date(`${y}`, 0, 1)),
                                end_date: formatDate(new Date(`${y}`, 11, 31)),
                            });
                        }}
                    />
                    <FullscreenOutlined
                        style={{ fontSize: "20px" }}
                        onClick={() => {
                            setEnableZoom(true);
                        }}
                    />
                </div>
            </div>
            {status == "success" ? (
                <Chart
                    chartType="LineChart"
                    data={chartData}
                    options={{
                        ...chartConfigs,
                    }}
                />
            ) : (
                <Spin
                    indicator={
                        <LoadingOutlined style={{ fontSize: 48 }} spin />
                    }
                />
            )}
            <Modal
                open={enableZoom}
                destroyOnClose
                onCancel={() => {
                    setEnableZoom(false);
                }}
                width={"fit-content"}
                height={"fit-content"}
                footer={""}
            >
                <Chart
                    chartType="LineChart"
                    data={chartData}
                    options={{
                        ...chartConfigs,
                        title: "Monthly Success(%)",
                        width: "80vw",
                        height: "70vh",
                    }}
                />
            </Modal>
        </Card>
    );
}

export default MonthlyChart;
